<template>
    <div class="container-outline">
        <div class="register">
            <div class="title">Register</div>
            <div class="top-squence">
                <head-register :dataSquence="{ id: 2, title: 'simulasi' }" />
            </div>
            <div class="content-register">
                <div class="container">
                    <form>
                        <div class="form-group">
                            <label for="">Kewarganegaraan</label>
                            <div class="wrap-input">
                                <select name="" id="" v-model="form.citizenship" class="form-input">
                                    <option value="" selected disabled>Pilih Kewarganegaraan</option>
                                    <option value="wna">Warga Negara Asing</option>
                                    <option value="wni">Warga Negara Indonesia</option>
                                </select>
                                <div v-if="$v.form.citizenship.$error">
                                    <div class="form-error" v-if="!$v.form.citizenship.required">
                                        Kewarganegaraan tidak boleh kosong
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="">No Identitas</label>
                            <div class="wrap-input-group">
                                <div>
                                    <select name="" id="" class="identity" v-model="form.identity_type" @change="chengeIdentityType">
                                        <option value="" selected disabled>Pilih identitas</option>
                                        <option value="KTP">KTP</option>
                                        <option value="KITAS">Kitas</option>
                                        <option value="Paspor">Paspor</option>
                                    </select>
                                    <div v-if="$v.form.identity_type.$error">
                                        <div class="form-error" v-if="!$v.form.identity_type.required">
                                            Identitas tidak boleh kosong
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <input
                                        type="text"
                                        placeholder="masukkan no identitas KTP/Passpor/SIM"
                                        class="form-input no-identity"
                                        v-model="form.ktp_no"
                                        @change="changePrint"
                                        @keyup="form.ktp_no = form.ktp_no.replace(/[^\d]/g, '')"
                                        max="16"
                                        min="16"
                                    />
                                    <div v-if="$v.form.ktp_no.$error">
                                        <div class="form-error" v-if="!$v.form.ktp_no.required">
                                            KTP tidak boleh kosong
                                        </div>
                                        <!-- <div class="form-error" v-if="!$v.form.ktp_no.minLength">Minimal {{ $v.form.ktp_no.$params.minLength.min }} karakter</div>
                    <div class="form-error" v-else-if="!$v.form.ktp_no.maxLength && max != 0">Maximal {{ $v.form.ktp_no.$params.maxLength.max }} karakter</div> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="">Tempat/Tanggal Lahir</label>
                            <div class="wrap-input-group">
                                <div>
                                    <input
                                        type="text"
                                        class="form-input tempat"
                                        placeholder="Nama kota Anda lahir"
                                        v-model="form.place_of_birth"
                                        required
                                        maxlength="25"
                                        @keyup="form.place_of_birth = form.place_of_birth.replace(/[^a-zA-Z\s]/g, '')"
                                    />

                                    <div v-if="$v.form.place_of_birth.$error">
                                        <div class="form-error" v-if="!$v.form.place_of_birth.required">
                                            Tempat Lahir tidak boleh kosong
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <label class="input-button" data-browse="Upload file">
                                        <input
                                            type="date"
                                            class="form-input birtday"
                                            placeholder="17/07/1995"
                                            v-model="form.date_of_birth"
                                            :max="today"
                                            required
                                            @change="changePrint"
                                        />
                                    </label>

                                    <div v-if="$v.form.date_of_birth.$error">
                                        <div class="form-error" v-if="!$v.form.date_of_birth.required">
                                            Tanggal Lahir tidak boleh kosong
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="">Alamat</label>
                            <div class="wrap-input">
                                <input
                                    type="text"
                                    class="form-input"
                                    placeholder="masukkan alamat anda"
                                    v-model="form.identity_address.address"
                                    @change="changePrint"
                                />
                                <div v-if="$v.form.identity_address.address.$error">
                                    <div class="form-error" v-if="!$v.form.identity_address.address.required">
                                        Alamat tidak boleh kosong
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="detail-alamat">Provinsi *</label>
                            <div class="wrap-input">
                                <input
                                    type="text"
                                    class="form-input"
                                    placeholder="Provinsi sesuai ktp"
                                    v-model="form.identity_address.province"
                                    required
                                    @keyup="form.identity_address.province = form.identity_address.province.replace(/[^a-zA-Z\s]/g, '')"
                                    @change="changePrint"
                                />
                                <div v-if="$v.form.identity_address.province.$error">
                                    <div class="form-error" v-if="!$v.form.identity_address.province.required">
                                        Profinsi tidak boleh kosong
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="detail-alamat">Kota *</label>
                            <div class="wrap-input">
                                <input
                                    type="text"
                                    class="form-input"
                                    placeholder="Kota sesuai ktp"
                                    v-model="form.identity_address.regency"
                                    required
                                    @keyup="form.identity_address.regency = form.identity_address.regency.replace(/[^a-zA-Z\s]/g, '')"
                                    @change="changePrint"
                                />
                                <div v-if="$v.form.identity_address.regency.$error">
                                    <div class="form-error" v-if="!$v.form.identity_address.regency.required">
                                        Kota tidak boleh kosong
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="detail-alamat">Kecamatan *</label>
                            <div class="wrap-input">
                                <input
                                    type="text"
                                    class="form-input"
                                    placeholder="Kecamatan sesuai ktp"
                                    v-model="form.identity_address.district"
                                    required
                                    @keyup="form.identity_address.district = form.identity_address.district.replace(/[^a-zA-Z\s]/g, '')"
                                    @change="changePrint"
                                />
                                <div v-if="$v.form.identity_address.district.$error">
                                    <div class="form-error" v-if="!$v.form.identity_address.district.required">
                                        Kecamatan tidak boleh kosong
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="detail-alamat">Kelurahan *</label>
                            <div class="wrap-input-group">
                                <div>
                                    <input
                                        type="text"
                                        class="form-input kecamatan"
                                        placeholder="Kelurahan sesuai ktp"
                                        v-model="form.identity_address.village"
                                        required
                                        @keyup="form.identity_address.village = form.identity_address.village.replace(/[^a-zA-Z\s]/g, '')"
                                        @change="changePrint"
                                    />
                                    <div v-if="$v.form.identity_address.village.$error">
                                        <div class="form-error" v-if="!$v.form.identity_address.village.required">
                                            Kelurahan tidak boleh kosong
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <span class="rt-rw">RT*</span>
                                    <input
                                        type="text"
                                        maxlength="3"
                                        class="form-input input-rt-rw"
                                        v-model="form.identity_address.neighborhood_no"
                                        required
                                        @keyup="form.identity_address.neighborhood_no = form.identity_address.neighborhood_no.replace(/[^\d]/g, '')"
                                        @change="changePrint"
                                    />
                                    <div v-if="$v.form.identity_address.neighborhood_no.$error">
                                        <div class="form-error" v-if="!$v.form.identity_address.neighborhood_no.required">
                                            RT tidak boleh kosong
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <span class="rt-rw rw">RW*</span>
                                    <input
                                        type="text"
                                        maxlength="3"
                                        class="form-input input-rt-rw"
                                        v-model="form.identity_address.citizen_no"
                                        required
                                        @keyup="form.identity_address.citizen_no = form.identity_address.citizen_no.replace(/[^\d]/g, '')"
                                        @change="changePrint"
                                    />
                                    <div v-if="$v.form.identity_address.citizen_no.$error">
                                        <div class="form-error" v-if="!$v.form.identity_address.citizen_no.required">
                                            Rw tidak boleh kosong
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="detail-alamat">Kodepos *</label>
                            <div class="wrap-input">
                                <input
                                    type="text"
                                    class="form-input pos-telepon kode-pos"
                                    placeholder="Masukkan kodepos"
                                    v-model="form.identity_address.postcode"
                                    required
                                    @keyup="form.identity_address.postcode = form.identity_address.postcode.replace(/[^\d]/g, '')"
                                    @change="changePrint"
                                    minlength="5"
                                    maxlength="5"
                                />
                                <div v-if="$v.form.identity_address.postcode.$error">
                                    <div class="form-error" v-if="!$v.form.identity_address.postcode.required">
                                        Kode Pos tidak boleh kosong
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                    <Simulasi :dataPrint="print" :statementSimulation="valueStatement" @updateValue="checkStatement" />
                    <div class="button">
                        <router-link to="/profil-perusahaan"><button class="btn-scondary">Sebelumnya</button></router-link>
                        <div></div>
                        <button class="btn-primer" type="submit" @click="registerKYC">
                            <b-spinner variant="light" small v-if="isLoading"></b-spinner>
                            <div v-else>Selanjutnya</div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import Simulasi from "../assets/filedownload/Simulasi.vue";
import moment from "moment";
import { required } from "vuelidate/lib/validators";
import HeadRegister from "./component/HeadRegister.vue";

export default {
    components: {
        Simulasi,
        HeadRegister,
    },

    data() {
        return {
            today: "",
            dataUser: "",
            isLoading: false,
            print: {
                fullname: "",
                alamat: "",
                telepone: "",
                ktp: "",
                pekerjaan: "",
                tandaTangan: null,
                noKantor: "",
                company_id: "",
                namaPejabat: "",
                jabatan: "",
                jabatanNasabah: "",
                no_ac_demo: "",
                tempat_ttd: "",
                complement: "",
                tanggalLahir: "",
                tempat_lahir: "",
                platform: [],
                statement: false,
            },
            form: {
                date_of_birth: "",
                ktp_no: "",
                place_of_birth: "",
                citizenship: "",
                identity_type: "",
                identity_address: {
                    ownership_status: "",
                    address: "",
                    citizen_no: "",
                    neighborhood_no: "",
                    village: "",
                    district: "",
                    regency: "",
                    province: "",
                    postcode: "",
                },
                has_set_trading_simulation: false,
                has_confirm_costumer: "",
                has_investment_experience: "",
                has_set_company_profile: "",
                has_set_investment_experience: "",
                has_set_mandate: "",
                has_set_risk: "",
                has_set_trading_rules: "",
                completeness_verification: "",
                disclosure_customer: "",
                disclosure_risk: "",
                disclosure_mandate: "",
                step: "simulation",
            },
            idCustomer: "",
            min: 0,
            max: 0,
            identity_type: "",
        };
    },
    validations() {
        return {
            form: {
                ktp_no: {
                    // minLength: minLength(this.min),
                    // maxLength: maxLength(this.max),
                    required,
                },
                date_of_birth: { required },
                place_of_birth: { required },
                citizenship: { required },
                identity_type: { required },
                identity_address: {
                    address: { required },
                    citizen_no: { required },
                    neighborhood_no: { required },
                    village: { required },
                    district: { required },
                    regency: { required },
                    province: { required },
                    postcode: { required },
                },
            },
        };
    },

    watch: {
        "form.dentity_address.address"() {
            if (this.form.identity_address.address) {
                this.print.alamat = this.form.identity_address.address;
            }
        },
        "form.has_set_trading_simulation"() {},
    },
    mounted() {
        var today = new Date();
        today.setFullYear(today.getFullYear());
        this.today = new Date().toISOString().split("T")[0];
        axios.get("/v2/user/profile").then((res) => {
            this.print.fullname = res.data.data.user.fullname;
            this.print.platform = res.data.data.user.platform;

            this.form.fullname = this.print.fullname;
        });

        axios.get("/v2/kyc/customer").then((res) => {
            let customer = res.data.data.customer;
            this.form.has_set_trading_simulation = customer.has_set_trading_simulation;
            this.form.has_confirm_costumer = customer.has_confirm_costumer;
            this.form.has_investment_experience = customer.has_investment_experience;
            this.form.has_set_company_profile = customer.has_set_company_profile;
            this.form.has_set_investment_experience = customer.has_set_investment_experience;
            this.form.has_set_mandate = customer.has_set_mandate;
            this.form.has_set_risk = customer.has_set_risk;
            this.form.has_set_trading_rules = customer.has_set_trading_rules;
            localStorage.setItem("status_kyc", customer.state);
            this.idCustomer = customer._id;
            this.form.identity_address.address = customer.identity_address.address;
            this.form.identity_address.postcode = customer.identity_address.postcode;
            this.form.identity_address.neighborhood_no = customer.identity_address.neighborhood_no;
            this.form.identity_address.citizen_no = customer.identity_address.citizen_no;
            this.form.identity_address.village = customer.identity_address.village;
            this.form.identity_address.telephone = customer.identity_address.telephone;
            this.form.identity_address.province = customer.identity_address.province;
            this.form.identity_address.regency = customer.identity_address.regency;
            this.form.identity_address.district = customer.identity_address.district;
            this.form.citizenship = customer.citizenship;
            this.form.date_of_birth = moment(customer.date_of_birth).format("YYYY-MM-DD");
            this.form.place_of_birth = customer.place_of_birth;
            this.form.completeness_verification = customer.completeness_verification;
            this.form.disclosure_customer = customer.disclosure_customer;
            this.form.disclosure_risk = customer.disclosure_risk;
            this.form.disclosure_mandate = customer.disclosure_mandate;

            this.form.identity_type = customer.identity_type;
            this.form.ktp_no = customer.ktp_no;

            this.print.alamat =
                this.form.identity_address.address +
                ", Kel." +
                this.form.identity_address.village +
                ", Kec." +
                this.form.identity_address.district +
                ", " +
                this.form.identity_address.regency +
                ", " +
                this.form.identity_address.province +
                ", " +
                this.form.identity_address.postcode;
            this.print.tempat_lahir = this.form.place_of_birth;
            this.print.tanggalLahir = this.form.date_of_birth;
            this.print.ktp = this.form.identity_type + " - " + this.form.ktp_no;
            this.print.statement = customer.has_set_trading_simulation;
            this.form.fullname = customer.fullname;
            this.form.identity_address.ownership_status = customer.identity_address.ownership_status;
            // this.form.dependent_no = customer.dependent_no;

            // this.form.domicile_address.address = customer.domicile_address.address;
            // this.form.domicile_address.postcode = customer.domicile_address.postcode;
            // this.form.domicile_address.neighborhood_no = customer.domicile_address.neighborhood_no;
            // this.form.domicile_address.citizen_no = customer.domicile_address.citizen_no;
            // this.form.domicile_address.village = customer.domicile_address.village;
            // this.form.domicile_address.province = customer.domicile_address.province;
            // this.form.domicile_address.regency = customer.domicile_address.regency;
            // this.form.domicile_address.district = customer.domicile_address.district;
        });
    },
    computed: {
        valueStatement() {
            let data = false;
            if (this.form.has_set_trading_simulation != undefined) {
                data = this.form.has_set_trading_simulation;
            }
            return data;
        },
    },

    methods: {
        checkStatement(event) {
            this.form.has_set_trading_simulation = event;
        },
        chengeIdentityType(e) {
            this.form.identity_type = e.target.value;
            if (this.form.identity_type == "paspor") {
                this.min = 5;
                this.max = 0;
            } else {
                this.min = 16;
                this.max = 16;
            }
        },
        changePrint() {
            this.print.alamat =
                this.form.identity_address.address +
                ", Kel." +
                this.form.identity_address.village +
                ", Kec." +
                this.form.identity_address.district +
                ", " +
                this.form.identity_address.regency +
                ", " +
                this.form.identity_address.province +
                ", " +
                this.form.identity_address.postcode;
            this.print.tanggalLahir = this.form.date_of_birth;
            this.print.tempat_lahir = this.form.place_of_birth;
            this.print.ktp = this.form.identity_type + " - " + this.form.ktp_no;
        },

        registerKYC() {
            this.$v.form.$touch();
            if (this.$v.form.$error) {
                return;
            }
            this.isLoading = true;
            let methode;
            if (this.idCustomer) {
                methode = {
                    url: "/v2/kyc/customer/" + this.idCustomer,
                    method: "PUT",
                    data: this.form,
                };
            } else {
                methode = {
                    url: "/v2/kyc/customer",
                    method: "POST",
                    data: this.form,
                };
            }
            if (this.form.has_set_trading_simulation) {
                axios(methode)
                    .then((res) => {
                        let status = res.data.data.status_code;
                        if (status == "00") {
                            this.isLoading = false;
                            this.$router.push("/investment-experience");
                        }
                    })
                    .catch((error) => {
                        this.isLoading = false;
                        console.log(error.response);
                        this.$notify({
                            group: "foo",
                            title: "Cek kembali inputan anda",
                            type: "error",
                            duration: 2000,
                        });
                    });
            } else {
                this.$toast.error("Statement Menerima belum disetujui");
                this.isLoading = false;
            }
        },
    },
};
</script>

<style scoped>
.container-outline {
    width: 70%;
    /* background: #fff; */
}

.top-squence {
    width: 85%;
    border-radius: 10px 10px 0 0;
    margin: 0 auto;
    background: #000e22;
    padding: 29px 20px;
    font-size: 14px;
}

.top-squence ul {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin: 0;
}

.top-squence ul li {
    list-style: none;
    text-align: center;
    font-size: 10px;
    color: #40688e;
    position: relative;
    width: 91px;
}

.top-squence ul li div {
    background: transparent;
    border: solid 0.1px #40688e;
    color: #40688e;
    border-radius: 50%;
    width: 27px;
    font-size: 16px;
    font-weight: 600;
    margin: 2px auto;
}

.li-active:first-child::before {
    display: none;
}

.li-active:nth-child(3)::before {
    border: dashed 1px #c59733;
}

.top-squence ul li div.squnce-active {
    position: relative;
    background: #c59733;
    color: #000e22;
    border: solid 0.5px #c59733;
}

.top-squence ul li div.squnce-process {
    position: relative;
    border: solid 0.5px #c59733;
    color: #c59733;
}

.form-input,
select {
    width: 73%;
    font-size: 12px;
    padding: 0.6rem 1rem;
    height: unset;
    border-radius: 7px;
    border: none;
    text-transform: capitalize;
    color: #707070;
    box-shadow: 0 1px 3px rgb(50 50 93 / 15%), 0 1px 0 rgb(0 0 0 / 2%);
}

select::first-letter,
select::first-line {
    text-transform: uppercase;
}

.form-input:focus,
select:focus {
    box-shadow: 0 1px 3px rgb(50 50 93 / 15%), 0 1px 0 rgb(0 0 0 / 2%);
}

.form-error {
    font-size: 12px;
    margin: 5px 0 0 0;
    color: #e74c3c;
}

.afiliasi {
    width: 100%;
    background: #2222;
    color: #ff6f00;
    text-align: center;
    position: absolute;
    left: 0;
    top: 0;
    margin-top: 62px;
    padding: 10px;
    height: 60px;
    line-height: 2.5;
}

.afiliasi img {
    width: 30px;
    margin-right: 10px;
}

.kecamatan {
    margin-right: 20px;
}

.rt-rw {
    font-size: 12px;
    margin-right: 10px;
}

.rw {
    margin-left: 22px;
}

.input-rt-rw {
    width: 60% !important;
    text-align: center;
}

.form-ttl-bagi {
    width: 23%;
    text-transform: lowercase;
}

.deactive {
    display: none;
}

.clickCheck {
    width: 17px;
    height: 20px;
    position: absolute;
    top: -7px;
    left: -2px;
    z-index: 3;
    cursor: pointer;
}

.npwpActive {
    display: block;
    transition: all 0.5s ease-out;
    position: relative;
    top: -20px;
}

.npwp-no {
    font-size: 14px;
}

.content-modal {
    background: white;
    width: 50%;
    margin: 5% auto;
    padding: 20px;
    border-radius: 10px;
}

.title-modal {
    height: 50px;
    font-size: 20px;
    font-weight: bold;
}

.close {
    margin-top: -32px;
}

.footer-modal {
    margin: 50px 22px 10px;
}

.footer-modal div {
    width: 100%;
    text-align: center;
    margin: 0 auto;
}

.show-content {
    display: none;
}

.modalActive {
    display: block;
}

.konfirmasi {
    font-size: 13px;
    margin: 50px 0 10px 0;
    width: 96.5%;
}

.konfirmasiYa {
    color: #2ecc71;
}

.konfirmsaiTidak {
    color: #e74c3c;
}

.input-bappebti {
    width: 20%;
    display: flex;
    justify-content: flex-end;
}

.form-platform {
    display: flex;
}

.input-babepti[type="radio"]:checked,
.input-babepti[type="radio"]:not(:checked) {
    position: absolute;
    left: -999999px;
    cursor: pointer;
}

.input-babepti[type="radio"]:checked + label {
    color: #c59733;
}

.label-babepti {
    width: 40px;
    cursor: pointer;
    font-weight: bold;
}

.bappebti {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    font-size: 14px;
}

.bappebti span {
    font-weight: bold;
    margin: 0 0 0 40px;
    cursor: pointer;
}

.bappebti span:hover {
    text-decoration: underline;
}

.label--checkbox {
    font-size: 13px;
    position: relative;
    margin-left: 20px;
}

.label-radio {
    width: 185px;
    cursor: pointer;
}

.outer {
    margin: 10px 25px 10px 15px;
}

.register {
    margin: 46px 0;
}

.pernyataan-bappebti {
    margin-bottom: 3rem;
}

.form-checkbox {
    display: flex;
}

form {
    width: 83%;
    margin: 0 auto;
}

label {
    font-size: 13px;
    width: 150px;
    display: inline-block;
    margin: unset;
}

.detail-alamat {
    width: 115px;
    margin: 0 0 0 30px;
}

.form-group,
.wrap-input-group {
    display: flex;
    align-items: center;
}

.wrap-input-group {
    gap: 2rem;
}

.form-group,
.wrap-input-group,
.wrap-input {
    width: 100%;
}

.wrap-input-group div {
    width: 100%;
}

.form-input {
    width: 100%;
}

.tempat {
    margin: 0 25px 0 0;
}

.tanggal {
    background: transparent;
    border: none;
    padding-right: 10px;
    text-transform: lowercase;
}

.birtday {
    background: transparent;
    border: none;
    padding-right: 3px;
    width: 100%;
    text-transform: lowercase;
}

.identity {
    width: 100%;
    margin-right: 1.3rem;
}
.no-identity {
    width: 100%;
}

.birtday::-webkit-calendar-picker-indicator {
    opacity: 0;
    cursor: pointer;
}

.tanggal::-webkit-calendar-picker-indicator {
    opacity: 0;
    cursor: pointer;
}

.input-button {
    height: 50px;
    position: relative;
    display: inline-flex;
    align-items: center;
    border: none;
    background: #f8f9fe;
    border-radius: 10px;
    top: 1px;
    margin-bottom: 0;
    width: 100%;
}

.input-button::after {
    content: "";
    position: absolute;
    width: 45px;
    height: 43px;
    background: url("../assets/calendar.svg") no-repeat center #000e22;
    background-size: 22px;
    right: 0;
    top: 0;
    border-top-right-radius: 9px;
    border-bottom-right-radius: 9px;
    border-left: inherit;
    cursor: pointer;
}

.pos-telepon {
    width: 25%;
}

.identitas {
    width: 20%;
    margin: 0 27px 0 0;
    background-position-x: 92%;
}

.no-identitas {
    width: 50%;
}

.form-ktp-bagi {
    width: 24%;
    margin-right: 30px;
}

.icon-calender {
    font-size: 20px;
    color: white;
}

.content-register {
    box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15);
    background: #ffffff;
    border-radius: 5px;
}

.title {
    font-size: 25px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    margin: 0 0 50px;
}

.navigation {
    margin: 0 0 50px;
    font-size: 10px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
}
.container {
    width: 90%;
    padding-top: 45px;
}

.nav-root {
    display: flex;
    justify-content: space-between;
    margin: 0 0 50px;
    position: relative;
    /* background-color: lightcyan; */
}

.list-root {
    list-style: none;
    width: 40%;
    padding: 15px;
    text-align: center;
    color: rgba(112, 112, 112, 0.5);
}

.active {
    border-top-right-radius: 15px;
    background-color: #c59733;
    color: white;
    position: relative;
    text-align: center;
    position: absolute;
    width: 20%;
    top: -54px;
}

.active:first-child {
    border-top-left-radius: 15px;
}

.active:last-child {
    border-top-right-radius: 15px;
    border-bottom-right-radius: 0;
}

input:disabled,
select:disabled {
    cursor: not-allowed;
}

.active::before {
    z-index: -1;
    position: absolute;
    content: "";
    display: inline-block;
    width: 50px;
    height: 65px;
    background-color: #1f354a;
    top: -2px;
    left: -41px;
    border: 2px solid #000e22;
}

.active:first-child::before {
    opacity: 0;
}

.button {
    display: flex;
    justify-content: space-between;
    padding: 76px 15px;
}

.sub-title {
    margin: 0 0 73px;
    font-size: 18px;
    font-weight: bold;
}

.arrow {
    margin-left: 10px;
    margin-right: 10px;
    border: solid #1f354a;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 4px;
    transform: rotate(45deg);
    vertical-align: super;
}

.wrap-arrow {
    position: absolute;
    display: inline-block;
    width: 56px;
    height: 48px;
    /* border: solid 1px; */
    right: 50px;
    top: 1px;
    border-radius: 10px;
    text-align: center;
    padding: 15px 9px;
    background: white;
}

.konfirmasi-ktp {
    width: 54%;
    position: relative;
    margin-left: auto;
}

.tanggal-aktif {
    width: 22%;
    text-transform: lowercase;
}

.identityActive {
    width: 20%;
    margin-right: 2%;
    /* display: none; */
}

.masa-aktif {
    font-size: 13px;
    margin-right: 10px;
}

.activeForm {
    display: inline-block;
}

@media (min-width: 768px) and (max-width: 1190px) {
    .list-root {
        font-size: 13px;
    }
    .active {
        padding: 10px;
        text-align: center;
        font-size: 13px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .active::before {
        width: 28px;
        left: -25px;
    }

    label,
    select,
    .form-input,
    .detail-alamat {
        width: 100%;
    }

    .no-identity {
        width: 30%;
    }

    .tempat {
        width: 55%;
    }
    .tanggal {
        width: 31%;
    }
    .identitas {
        width: 35%;
    }

    .no-identitas {
        width: 60%;
    }

    .provincy,
    .city,
    .kecamatan {
        margin-left: 30px;
        width: 94.5%;
    }

    .kode-pos {
        margin-left: 30px;
        width: 25%;
    }

    .input-button {
        right: 0;
        width: 40%;
        top: 30px;
    }
}

@media (max-width: 768px) {
    .container-outline {
        width: 90%;
    }

    form {
        width: 100%;
    }

    li > span {
        display: none;
    }

    .form-group,
    .wrap-input-group {
        flex-direction: column;
        align-items: flex-start;
        gap: 0.5rem;
    }

    .wrap-input-group div {
        width: 100%;
    }

    .form-input,
    label,
    select,
    .input-button {
        width: 100%;
    }

    .birtday,
    .kecamatan,
    .input-rt-rw {
        width: 100% !important;
        text-align: left;
    }

    .register {
        margin: 20px 0;
    }

    .title {
        font-size: 18px;
        margin: 0 0 20px;
    }

    .sub-title {
        margin-bottom: 20px;
    }

    .top-squence {
        width: 100%;
        padding: 15px 10px;
    }

    .container {
        width: 100%;
        padding: 25px 20px;
    }

    /* .identitas,
  .form-ktp-bagi,
  .tanggal-aktif,
  .tempat,
  .kecamatan,
  .input-rt-rw {
    margin: 0 0 10px;
  } */

    .detail-alamat,
    .rt-rw {
        margin: 0 0 0.5rem;
    }

    .form-checkbox {
        align-items: flex-start;
    }

    .label--checkbox {
        margin-left: 10px;
    }

    .button {
        display: block;
        width: 100%;
        padding: 25px 20px;
        text-align: center;
    }

    .btn-scondary,
    .btn-primer {
        width: 100%;
    }

    .btn-scondary {
        margin-bottom: 20px;
    }

    .content-modal {
        width: 95%;
    }

    .wrap-document {
        width: 100%;
        padding: 30px 0;
    }

    .form-error {
        margin-left: 0;
    }
}
</style>
